import { Component, Input, Signal, WritableSignal, computed, signal } from '@angular/core';
import { FulfillmentOrderStatus } from '@vendasta/order-fulfillment';
import { DisplayedStatusValuesEnum, fulfillmentOrderStatusToString, statusColorMap } from '../utils';
import { WorkOrderPersona } from '../work-order-landing-page/interfaces';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'work-order-status-badge',
  templateUrl: './status-badge.component.html',
  styleUrls: ['./status-badge.component.scss'],
  standalone: true,
  imports: [GalaxyBadgeModule, MatIconModule, TranslateModule],
})
export class StatusBadgeComponent {
  @Input() set persona(persona: WorkOrderPersona) {
    this._persona.set(persona);
  }
  @Input() set value(value: FulfillmentOrderStatus) {
    this._foStatus.set(value);
  }
  @Input() clickableMenu = false;

  private _persona: WritableSignal<WorkOrderPersona> = signal(WorkOrderPersona.VENDOR);
  private _foStatus: WritableSignal<FulfillmentOrderStatus> = signal(
    FulfillmentOrderStatus.FULFILLMENT_ORDER_STATUS_UNSET,
  );
  displayedColor: Signal<string> = computed(() => statusColorMap?.get(this._persona())?.get(this._foStatus()) || '');
  displayedValue: Signal<DisplayedStatusValuesEnum> = computed(() =>
    fulfillmentOrderStatusToString(this._foStatus(), this._persona()),
  );
}
